import type { ProductInfo } from "@expert/contentful";
import { Card, Flex, Text } from "@mantine/core";
import { GreenCheckMark } from "@/sales-tools/icons/GreenCheckMark";

export function PlanBenefits({ productInfo: { planBenefits } }: { productInfo: ProductInfo }) {
    if (!planBenefits?.length) return null;

    return (
        <Card bg="dark.6" radius="md" p="1rem 0.75rem" w="100%">
            {planBenefits.map((pb) => (
                <Flex mt="3xs" key={pb}>
                    <GreenCheckMark />
                    <Text ml="3xs" size="xs" c="dark.1">
                        {pb}
                    </Text>
                </Flex>
            ))}
        </Card>
    );
}
